export const alphaNumericRegEx = /[^a-zA-Z0-9]/g;
//not only leading and trailing but also spaces within the string
export const alphaNumericRegExWithSpace = /[^a-zA-Z0-9 ]/g;
